import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
const CTAButton = () => {
  const handleClick = () => {
    // Track click event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'BareEarth Grounding Sheets',
        content_category: 'Health',
        value: 109.99,
        currency: 'USD'
      });
    }
  };
  return <div className="border border-gray-300 rounded p-4 bg-white shadow-sm" data-id="element-533">
      <div className="text-sm uppercase tracking-wide text-gray-600 mb-2 font-medium flex items-center" data-id="element-534">
        <TagIcon className="h-3 w-3 mr-1" data-id="element-535" />
        <span data-id="element-536">Reader Access</span>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-537">
        <div className="mb-3 sm:mb-0" data-id="element-538">
          <div className="text-lg font-serif font-medium text-gray-900" data-id="element-539">
            BareEarth Grounding Sheets
          </div>
          <div className="text-sm text-gray-600 flex items-center" data-id="element-540">
            <span className="line-through mr-2" data-id="element-541">$219.98</span>
            <span className="font-medium text-green-700" data-id="element-542">$109.99</span>
            <span className="ml-2 text-xs bg-yellow-100 px-2 py-0.5 rounded border border-yellow-200" data-id="element-543">
              50% OFF
            </span>
          </div>
        </div>
        <a href="https://offer.bareearthlife.com/groundedsheets/checkout?oid=858&affid=719" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="bg-gray-800 hover:bg-gray-900 text-white font-medium py-2 px-4 rounded border border-gray-900 inline-flex items-center transition-colors shadow-sm" data-id="element-544">
          <span data-id="element-545">Access Offer</span>
          <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-546" />
        </a>
      </div>
    </div>;
};
export default CTAButton;